export default {
    user(state) {
        return state.user
    },
    userInfo(state) {
        return state.userInfo
    },
    books(state) {
        return state.books;
    },
    bookflow(state) {
        return state.bookflow
    },
    backend(state) {
        return state.backend
    },
    urlApiServer(state) {
        return state.apiUrl
    },
    accessTokenGetter(state){
        return state.accessToken
    }

}